export default __webpack_public_path__ + "static/media/element_82.171e2347.jpg";